module.exports = __webpack_public_path__ + "img/download-1.439fef87.webp";